import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { Header } from '../../common/header/Header';
import { LargeHeader } from '../../common/largeHeader/LargeHeader';
import logoUrl from '../../../styles/assets/nei_logo_2x.png';
import _811Url from '../../../styles/assets/811_logo_2x.png';
import clearLaunchUrl from '../../../styles/assets/clearlaunch_logo_2x.png';
import * as routePaths from '../../routePaths';
import SmartBanner from '../../common/smartBanner';
import Shovel from '../../../styles/assets/Shovel.jpg';

import './mainLayout.scss';
import HomeHeader from "../../common/homeHeader/HomeHeader";

/**
 * The MainLayout component.
 */
export class MainLayout extends React.Component {
  /**
   * @constructors
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="main-layout">
        <SmartBanner
          title={'Safe Excavator'}
          price={'Free'}
          author={''}
          androidURL={'https://play.google.com/store/apps/details?id=com.clearlaunch.safeexcavator'}
          appleURL={'https://apps.apple.com/us/app/safe-excavator/id1323108596'}
          appIcon={Shovel}
        />
        {
          this.props.largeHeader ? (
            <HomeHeader/>
            ) : (
            <Header
              pageTitle={this.props.pageTitle}
              location={this.props.location}
              match={this.props.match}
              section={this.props.section}
              hasVideo={this.props.hasVideo}
            />
          )
        }
        <main id="main-container" role="main">
          {this.props.page}
        </main>
        <footer className="footer">
          <div className="container-fluid footer-sitemap-row">
            <div className="row">
              <div className="container">
                <div className="row">
                  <div className="col-md-5">
                    <div className="row left-side">
                      <div className="col-12 col-lg-4 pr-lg-0 logo-column">
                        <img className="footer-sitemap-logo" src={logoUrl} />
                      </div>
                      <div className="col-12 col-lg-8 left-text">
                        <p>The National Excavator Initiative, a 501(c)(3), is an effort to raise the awareness of a critically important program 811.</p>
                        <p>Contacting 811 before digging is the single most critical action an excavator can take to
                          help ensure their health and safety are protected, while at the same time preventing financial
                          harm and environmental impact.</p>
                        <img className="footer-sitemap-811-img" src={_811Url} />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7">
                    <div className="row right-side">

                      <div className="col-12 col-sm-2">
                        <ul className="sitemap-links-list">
                          <li className="sitemap-links-title"><Link className="sitemap-link" to={routePaths.homeRoute}>Home</Link></li>
                        </ul>
                      </div>

                      <div className="col-12 col-sm-2">
                        <ul className="sitemap-links-list">
                          <li className="sitemap-links-title">811</li>
                          <li><Link className="sitemap-link" to={routePaths.eightOneOneRoute}>Overview</Link></li>
                          <li><Link className="sitemap-link" to={routePaths.statesRoute}>State Laws</Link></li>
                          <li><Link className="sitemap-link" to={routePaths.safeDigging}>Safe Digging Checklist</Link></li>
                        </ul>
                      </div>

                      <div className="col-12 col-sm-4">
                        <ul className="sitemap-links-list">
                          <li className="sitemap-links-title">UNDERGROUND INFRASTRUCTURE </li>
                          <li><Link className="sitemap-link" to={routePaths.undergroundInfrastructureRoute}>Overview</Link></li>
                          <li>
                            <Link className="sitemap-link" to={routePaths.ugiPipelinesRoute}>Pipelines</Link>
                            <ul className="footersubMenu">
                              <li><Link className="sitemap-link sitemap-links-bullet" to={routePaths.markersRoute}>Markers</Link></li>
                              <li><Link className="sitemap-link sitemap-links-bullet" to={routePaths.preventionMeasuresRoute}>Prevention Measures</Link></li>
                              <li><Link className="sitemap-link sitemap-links-bullet" to={routePaths.leakRecognitionRoute}>Leak Recognition</Link></li>
                              <li><Link className="sitemap-link sitemap-links-bullet" to={routePaths.responseRoute}>Leak Response</Link></li>
                              <li><Link className="sitemap-link sitemap-links-bullet" to={routePaths.eooDamageReportingRoute}>Damage Reporting</Link></li>
                            </ul>
                          </li>

                          <li><Link className="sitemap-link" to={routePaths.ugiCommunicationsRoute}>Communication</Link></li>
                          <li><Link className="sitemap-link" to={routePaths.ugiElectricityRoute}>Electric</Link></li>
                          <li><Link className="sitemap-link" to={routePaths.ugiWaterSewerRoute}>Water & Sewer</Link></li>
                          <li><Link className="sitemap-link" to={routePaths.resourcesRoute}>Resources</Link></li>
                        </ul>
                      </div>

                      <div className="col-12 col-sm-4">
                        <ul className="sitemap-links-list">
                          <li className="sitemap-links-title">NEI</li>
                          <li><Link className="sitemap-link" to={routePaths.goalsRoute}>Goals</Link></li>
                          {/* <li><Link className="sitemap-link" to={routePaths.supportingCompaniesRoute}>Supporting Companies</Link></li>
                          <li><Link className="sitemap-link" to={routePaths.registerRoute}>Contribute</Link></li> */}
                        </ul>

                          <ul className="sitemap-links-list">
                            <li><Link className="sitemap-link" to={routePaths.termsAndConditions}>Terms and Conditions</Link></li>
                            <li><Link className="sitemap-link" to={routePaths.privacyPolicy}>Privacy Policy</Link></li>
                          </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*dont have time to find and remove the fonts so inline them */}
          <div className="container-fluid">
            <div className="row">
              <div className="container post-footer-container">
                <div className="row">
                  <div className="col-12 col-md-6" style={{fontSize: '12.8px'}}>
                    <i className="fa fa-copyright" style={{fontSize: '12.8px', marginBottom: '20px'}}/> {new Date().getFullYear()} National Excavator Initiative. <span className="text-uppercase">All rights reserved.</span>
                    <p className="footer-disclaimer" style={{fontSize: '9.6px'}}>DISCLAIMER: NEI AND OTHERS INVOLVED IN THIS WEBSITE, RELATED VIDEOS, AND SAFE EXCAVATOR APP DO NOT EXERCISE ANY CONTROL OVER 811 AND UNDERTAKE NO LIABILITY FOR ANY CLAIM ARISING IN CONNECTION WITH ANY USE OF THE 811 SYSTEM.</p>
                  </div>
                  <div className="col col-12 col-md-6">
                    <p style={{fontSize: '12.8px'}} className="footer-clear-launch float-none float-md-right"><span className="poweredByText">Powered by:&nbsp;</span><a href="https://www.clearlaunch.com"><img src={clearLaunchUrl} target="_blank"/></a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

MainLayout.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    params: PropTypes.object,
    path: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  page: PropTypes.element.isRequired,
  largeHeader: PropTypes.bool,
  hasVideo:PropTypes.bool
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/mainLayout/MainLayout.js